const musicIdArray = [
  "3IoDK8qI",
  "Ap1mYWUe",
  "E__uooMp",
  "jE4Mjfr0",
  "ZB1rIJBa",
  "q93dx7mD",
  "E3K8KWYi",
  "1I2Ua0sr",
  "e35rkcCF",
  "uhMSED1t",
  "J1S3ehx5",
  "SVLYcqv6",
  "67socqCG",
  "Ni6noMmw",
  "Cyu6QA-C",
  "MBAeAkci",
  "hN5sbCBi",
  "uuh6_aKT",
  "UuGteRjX",
  "1a_MxvYZ",
  "FNCDbofq",
  "SM-rvz75",
  "csaEsVWV",
  "uzJ8lxvw",
  "OhnxgY6_",
  "Suwo5AON",
];

function getRandomElement<T>(arr: T[]): T {
  if (!Array.isArray(arr) || arr.length === 0) {
    throw new Error("Input must be a non-empty array.");
  }
  const randomIndex = Math.floor(Math.random() * arr.length);
  return arr[randomIndex];
}

export { getRandomElement, musicIdArray };
